var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongjinOH
 * @contact hjoh@detech.co.kr
 * @date 2023-04-20
 * @brief SEI 진단점검하기 컴포넌트
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
// recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { alertState, checkTypeState } from "../../../../../recoil/assessmentState";
import { reLoad, reLoadPage, userInfoLoginState } from "../../../../../recoil/userState";
// utils
import { langId } from "../../../../../recoil/langState";
import { loadingBoxState } from "../../../../../recoil/menuState";
import * as HTTPUTIL from "../../../../../utils/api/HttpUtil";
import * as CUTIL from "../../../../../utils/commUtils";
import * as CONST from "../../../../../utils/Const";
import { useTrans } from "../../../../../utils/langs/useTrans";
import ConfirmPop from "../../../../common/popup/ConfirmPop";
function CheckView(props) {
    const t = useTrans();
    // recoil
    const [check, setCheck] = useRecoilState(checkTypeState);
    const userInfo = useRecoilValue(userInfoLoginState);
    const [reload, setReload] = useRecoilState(reLoad);
    const setReloadPage = useSetRecoilState(reLoadPage);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [alert, setAlert] = useRecoilState(alertState);
    const langIds = useRecoilValue(langId);
    // props
    const { appPath, handleOpenPop, checkItem } = props;
    // useState
    const [checkViewItem, setCheckViewItem] = useState(null);
    const [checkInput, setCheckInput] = useState("");
    const tabData = [
        { name: t("라벨.점검가이드"), id: 1 },
        { name: t("라벨.조치내용"), id: 2 },
        { name: t("라벨.비고"), id: 3 },
        { name: t("라벨.사진첨부"), id: 4 },
    ];
    const [tabNum, setTabNum] = useState(checkViewItem && checkViewItem.checkGuide.length > 0 ? tabData[0].id : tabData[1].id);
    const [action, setAction] = useState("");
    const [comment, setComment] = useState("");
    const [potoName, setPotoName] = useState("");
    const [file, setFile] = useState([]);
    const [uploadFiles, setUploadFiles] = useState([]);
    const [imageInfo, setImageInfo] = useState(null);
    const [groupName, setGroupName] = useState("");
    const lastNum = 10;
    const [url, setUrl] = useState(null);
    const [errorList, setErrorList] = useState([]);
    const [checkRefItem, setCheckRefItem] = useState([]);
    const [checkRefView, setCheckRefView] = useState([]);
    const [oddData, setOddData] = useState([]);
    const [evenData, setEvenData] = useState([]);
    // 프로그래스바
    let processRate = check.processRate * 100;
    let persent = processRate.toString().split(".")[0];
    // width 1650 Check용
    const [is1650M, setIs1650M] = useState(false);
    useEffect(() => {
        // resize handler
        // Mobile 체크
        function handleResize() {
            if (window.innerWidth <= 1650) {
                setIs1650M(true);
            }
            else {
                setIs1650M(false);
            }
        }
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    });
    // isMobile 여부 랜더링 후 확인
    useDebounceEffect(() => __awaiter(this, void 0, void 0, function* () {
        if (window.innerWidth <= 1650) {
            setIs1650M(true);
        }
    }), 100);
    useEffect(() => {
        //이미지 수정
        handleOpenPop("pop-edit-image", _jsx(ImageEditPop, { imageInfo: imageInfo, groupName: groupName, setGroupName: setGroupName, htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: "\uC0AC\uC9C4\uC81C\uBAA9" }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => ClosePop("pop-edit-image") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
        //이미지 삭제
        handleOpenPop("pop-delete-image", _jsx(ImageDeletePop, { imageInfo: imageInfo }));
        handleOpenPop("pop-img", _jsx(ImagePop, { url: url, htmlClose: _jsx(_Fragment, { children: _jsx("h1", { children: groupName }) }) }));
        handleOpenPop("pop-confirm", _jsx(ConfirmPop, { type: "check", clickfn: CheckDoneClick, profn: persent }));
    }, []);
    function ClosePop(id) {
        CUTIL.jsclose_Popup(id);
    }
    let chekPath = appPath;
    chekPath = chekPath + `&checkitemId=${check.checkitemId}`;
    // 진단점검 우측 API
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/checksheet/checkitem/checkvalue${chekPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: chekPath + reload + langIds,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setCheckViewItem(data.body);
                setErrorList([]);
                setCheck(Object.assign(Object.assign({}, check), { listType: data.body.type, checkvalueId: data.body.checkValue ? data.body.checkValue.checkvalueId : 0, checkvalue: {
                        action: data.body.checkValue ? data.body.checkValue.action : "",
                        comment: data.body.checkValue ? data.body.checkValue.comment : "",
                        input: data.body.checkValue ? data.body.checkValue.input : -1,
                        isChecked: data.body.checkValue ? data.body.checkValue.isChecked : false,
                        value: data.body.checkValue ? data.body.checkValue.value : -1,
                    }, checkRef: data.body.checkItemRef.length > 0 ? data.body.checkItemRef : [] }));
                setAction(data.body.checkValue ? data.body.checkValue.action : "");
                setComment(data.body.checkValue ? data.body.checkValue.comment : "");
                setPotoName("");
                setFile([]);
                if (data.body.checkValue) {
                    setUploadFiles(data.body.checkValue.image);
                }
                else {
                    setUploadFiles([]);
                }
                if (check.checkitemId !== check.preCheckitemId) {
                    setTabNum(data.body.checkGuide.length > 0 ? tabData[0].id : tabData[1].id);
                }
                if (data.body.type == 3) {
                    if (data.body.checkItemRef.length > 0) {
                        if (data.body.checkValue) {
                            setCheckRefView(data.body.checkValue.checkRefValue);
                            data.body.checkValue.checkRefValue.forEach((item, index) => {
                                if (index % 2 === 0) {
                                    setEvenData((prevData) => [...prevData, item]);
                                }
                                else {
                                    setOddData((prevData) => [...prevData, item]);
                                }
                            });
                        }
                        setCheckRefItem(data.body.checkItemRef.map((copy) => (Object.assign(Object.assign({}, copy), { measureValue: null, checkRefValueId: copy.checkitemrefId }))));
                    }
                }
            }
        }
    }, [data, langIds]);
    // 처음 선택 시 POST API
    function ChekPost(items) {
        return __awaiter(this, void 0, void 0, function* () {
            if (check.checkvalue.value) {
                let data = null;
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "POST",
                    appPath: `/checksheet/checkitem/checkvalue`,
                    appQuery: {
                        assessmentId: check.assessmentId,
                        checkitemId: check.checkitemId,
                        action: items.action,
                        comment: items.comment,
                        input: items.input,
                        isChecked: items.isChecked,
                        value: items.value,
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setReload(true);
                        setCheck(Object.assign(Object.assign({}, check), { checkvalueId: data.body.checkvalueId, preCheckitemId: check.checkitemId, checkvalue: {
                                action: data.body.action,
                                isChecked: data.body.isChecked,
                                value: data.body.value,
                                input: data.body.input,
                                comment: data.body.comment,
                            } }));
                        setReload(false);
                    }
                    else {
                        // need error handle
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList.map((err) => err.msg) }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                }
            }
        });
    }
    // 점수 PUT api
    function ChekPut(items, type) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/checksheet/checkitem/checkvalue/${check.checkvalueId}`,
                appQuery: {
                    action: items.action,
                    comment: items.comment,
                    input: items.input,
                    isChecked: items.isChecked,
                    value: items.value,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    setCheck(Object.assign(Object.assign({}, check), { checkitemId: check.checkitemId, preCheckitemId: check.checkitemId, checkvalue: {
                            action: data.body.action,
                            isChecked: data.body.isChecked,
                            value: data.body.value,
                            input: data.body.input,
                            comment: data.body.comment,
                        } }));
                    setReload(false);
                    if (type !== "list") {
                        if (tabNum == 2) {
                            setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.조치내용이저장되었습니다") }));
                            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        }
                        else if (tabNum == 3) {
                            setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.비고가저장되었습니다") }));
                            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        }
                    }
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    //점수 클릭
    function CheckViewClick(e, item) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            let items = {
                action: action,
                comment: comment,
                isChecked: false,
                value: item.score,
            };
            if (check.checkvalueId <= 0) {
                // 화면에 그리기위해 사용F
                setCheck(Object.assign(Object.assign({}, check), { checkvalue: {
                        action: items.action,
                        isChecked: false,
                        value: items.value,
                        input: check.checkvalue.input,
                        comment: items.comment,
                    } }));
                ChekPost(items);
            }
            else {
                ChekPut(items, "list");
            }
        });
    }
    // 판정 불가
    function CheckViewChecked(e) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            let items = {
                action: check.checkvalue.action,
                comment: check.checkvalue.comment,
                input: check.checkvalue.input,
                isChecked: true,
                value: check.checkvalue.value,
            };
            if (check.checkvalueId <= 0) {
                ChekPost(items);
            }
            else {
                ChekPut(items, "list");
            }
        });
    }
    // type2
    function onChangeInput(e) {
        let value = e.target.value;
        let numValue = value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
        if (numValue == value) {
            setErrorList(errorList.filter((err) => err.field !== "input"));
            setCheckInput(numValue);
        }
        else {
            setErrorList([{ field: "input", msg: t("라벨.숫자만입력") }]);
        }
    }
    // Type2 점수 적용
    function CheckInputClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/checksheet/checkitem/range`,
                appQuery: {
                    checkitemId: check.checkitemId,
                    input: checkInput,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    let items = {
                        action: check.checkvalue.action,
                        comment: check.checkvalue.comment,
                        value: data.body.score,
                        isChecked: false,
                        input: data.body.value,
                    };
                    // 처음
                    if (check.checkvalueId <= 0) {
                        ChekPost(items);
                    }
                    else {
                        ChekPut(items, "list");
                    }
                }
                else {
                    setErrorList(data.errorList);
                }
            }
            setCheckInput("");
        });
    }
    // 탭 이동
    function TabClick(item) {
        setTabNum(item.id);
    }
    // 조치내용, 비고
    function CheckPut(e, type) {
        return __awaiter(this, void 0, void 0, function* () {
            if (check.checkvalueId) {
                if (type == "action") {
                    let items = {
                        action: action,
                        comment: check.checkvalue.comment,
                        value: check.checkvalue.value,
                        isChecked: check.checkvalue.isChecked,
                        input: check.checkvalue.input,
                    };
                    ChekPut(items, "action");
                }
                else {
                    let items = {
                        comment: comment,
                        action: check.checkvalue.action,
                        value: check.checkvalue.value,
                        isChecked: check.checkvalue.isChecked,
                        input: check.checkvalue.input,
                    };
                    ChekPut(items, "comment");
                }
            }
            else {
                if (type == "action") {
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.진단점검항목의판정이후에조치내용을입력하세요") }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
                else {
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.진단점검항목의판정이후에비고내용을입력하세요") }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    // 첨부파일 저장
    function saveFileImage(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const files = e.target.files;
            let imageUpload = [...file];
            for (let i = 0; i < files.length; i++) {
                //  미리보기 구현시 필요 URL.createObjectURL(file[i]);
                imageUpload.push(files[i]);
            }
            if (imageUpload.length > lastNum) {
                imageUpload = imageUpload.slice(0, 10);
                setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "첨부파일은 10개 까지 가능합니다." }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
            }
            setFile(imageUpload);
            e.target.value = ""; // file name 초기화
        });
    }
    // 이미지 삭제
    function onClickAttachFileDelete(index) {
        setFile(file.filter((_, idx) => idx !== index));
    }
    // 첨부파일 업로드
    function uploadFileImage(e) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!check.checkvalueId) {
                setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.진단점검항목의판정이후에업로드하세요") }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
            }
            else {
                if (!potoName) {
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.사진제목입력") }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
                else {
                    if (file.length + uploadFiles.length <= lastNum) {
                        setRecoilIsLoadingBox(true);
                        const formData = new FormData();
                        // 파일 데이터 저장
                        file.map((files) => formData.append("files", files));
                        let data = null;
                        data = yield HTTPUTIL.PromiseHttp({
                            httpMethod: "POSTF",
                            appPath: `/images/checkvalue?checkvalueId=${check.checkvalueId}&groupName=${potoName}`,
                            appQuery: formData,
                            userToken: userInfo.loginInfo.token,
                        });
                        if (data) {
                            if (data.codeNum == CONST.API_200) {
                                setReload(true);
                                setPotoName("");
                                setFile([]);
                                setCheck(Object.assign(Object.assign({}, check), { checkitemId: check.checkitemId, preCheckitemId: check.checkitemId }));
                                setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.body }));
                                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                                setReload(false);
                                setRecoilIsLoadingBox(false);
                            }
                            else {
                                // need error handle
                                setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList !== null ? data.errorList.map((err) => err.msg) : t("라벨.사진첨부하세요") }));
                                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                                setRecoilIsLoadingBox(false);
                            }
                        }
                    }
                    else {
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "첨부파일은 10개 까지 가능합니다." }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                }
            }
        });
    }
    // 삭제, 수정, 이미지 팝업
    function ImageInfo(e, item) {
        setGroupName(item.groupName);
        setImageInfo(item);
        setUrl(item.url);
        CUTIL.jsopen_Popup(e);
    }
    // 다음 진단 점검
    function NextCheckLsit(e) {
        let checkitemId = null;
        checkItem.filter((ckf) => ckf.itemNum == check.itemNum + 1).map((ckf) => (checkitemId = ckf.checkitemId));
        setCheck(Object.assign(Object.assign({}, check), { checkitemId: checkitemId, preCheckitemId: -1, itemNum: check.itemNum + 1 }));
        setTabNum(checkViewItem.checkGuide.length > 0 ? 1 : 2);
    }
    // 마지막 선택
    function LastCheckLsit(e) {
        setCheck(Object.assign(Object.assign({}, check), { itemNum: check.endpage + 1, preCheckitemId: -1 }));
        setTabNum(checkViewItem.checkGuide.length > 0 ? 1 : 2);
    }
    // 이전선택
    function preCheckList(e) {
        let checkitemId = null;
        checkItem.filter((ckf) => ckf.itemNum == check.itemNum - 1).map((ckf) => (checkitemId = ckf.checkitemId));
        setCheck(Object.assign(Object.assign({}, check), { checkitemId: checkitemId, preCheckitemId: -1, itemNum: check.itemNum - 1 }));
        setTabNum(checkViewItem.checkGuide.length > 0 ? 1 : 2);
    }
    // 모바일 적용
    function M1650Pop(e, num) {
        if (num <= 1) {
            CUTIL.jsopen_m_1650_Popup(e);
            setTabNum(num);
        }
        else {
            if (!check.checkvalueId) {
                setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "진단점검 항목의 판정 이후에 선택하세요." }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
            }
            else {
                CUTIL.jsopen_m_1650_Popup(e);
                setTabNum(num);
            }
        }
    }
    // 상세 정보 닫기
    function closePopup(id) {
        const infoPop = document.getElementById(id);
        var body = document.body;
        var dimm = body.querySelector(".dimm");
        if (!CUTIL.isnull(infoPop)) {
            infoPop.classList.add("m-hidden");
            infoPop.classList.remove("popup-layer");
            infoPop.classList.remove("js-layer");
            infoPop.classList.remove("popup-type1");
            infoPop.removeAttribute("style");
            if (!CUTIL.isnull(body))
                body.removeAttribute("style");
            if (!CUTIL.isnull(dimm))
                dimm.removeAttribute("style");
            return;
        }
    }
    //결과 확인
    function CheckDoneClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/assessment/${check.assessmentId}`,
                appQuery: {
                    totalComment: null,
                    isTempSave: false,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    setCheck(Object.assign(Object.assign({}, check), { nextStep: "result", assessmentInfo: {
                            isTempSave: false,
                            reportId: check.assessmentInfo.reportId,
                        } }));
                    setReload(false);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.body.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
            setReload(false);
        });
    }
    //type3 번
    function onChangeInputType(e, itme) {
        setErrorList(errorList.filter((err) => err.field !== "checkRefValues"));
        setCheckRefItem(checkRefItem.map((smenu) => smenu === itme ? Object.assign(Object.assign({}, smenu), { measureValue: e.target.value.length > 0 ? e.target.value : null }) : smenu));
    }
    function CheckType3(e) {
        let itemArr = [];
        for (let i = 0; i < checkRefItem.length; i++) {
            itemArr.push({
                checkItemRefId: checkRefItem[i].checkRefValueId,
                measureValue: checkRefItem[i].measureValue,
            });
        }
        let items = {
            action: null,
            comment: null,
            input: null,
            isChecked: itemArr.filter((non) => non.measureValue).length > 0 ? false : true,
            value: null,
            checkRefValues: itemArr,
        };
        if (check.checkvalueId <= 0) {
            ChekPostType3(items);
        }
        else {
            ChekPutType3(items);
        }
    }
    // 처음 선택 시 POST API
    function ChekPostType3(items) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: `/checksheet/checkitem/checkvalue`,
                appQuery: {
                    assessmentId: check.assessmentId,
                    checkitemId: check.checkitemId,
                    action: items.action,
                    comment: items.comment,
                    input: items.input,
                    isChecked: items.isChecked,
                    value: items.value,
                    checkRefValues: items.checkRefValues,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    setCheck(Object.assign(Object.assign({}, check), { checkvalueId: data.body.checkvalueId, preCheckitemId: check.checkitemId, checkvalue: {
                            action: data.body.action,
                            isChecked: data.body.isChecked,
                            value: data.body.value,
                            input: data.body.input,
                            comment: data.body.comment,
                        } }));
                    setReload(false);
                }
                else {
                    // need error handle
                    if (data.errorList) {
                        setErrorList(data.errorList);
                    }
                    else {
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: CONST.ERROR_MSG }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                }
            }
        });
    }
    // 점수 PUT api
    function ChekPutType3(items) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/checksheet/checkitem/checkvalue/${check.checkvalueId}`,
                appQuery: {
                    action: items.action,
                    comment: items.comment,
                    input: items.input,
                    isChecked: items.isChecked,
                    value: items.value,
                    checkRefValues: items.checkRefValues,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    setCheck(Object.assign(Object.assign({}, check), { checkitemId: check.checkitemId, preCheckitemId: check.checkitemId, checkvalue: {
                            action: data.body.action,
                            isChecked: data.body.isChecked,
                            value: data.body.value,
                            input: data.body.input,
                            comment: data.body.comment,
                        } }));
                    setReload(false);
                }
                else {
                    // need error handle
                    if (data.errorList) {
                        setErrorList(data.errorList);
                    }
                    else {
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: CONST.ERROR_MSG }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                }
            }
        });
    }
    return (_jsx(_Fragment, { children: checkViewItem && (_jsxs("article", Object.assign({ className: "box w100p" }, { children: [_jsxs("div", Object.assign({ className: "box__header flex-column" }, { children: [_jsxs("h2", { children: [_jsx("strong", { children: checkViewItem.name }), _jsx("span", {})] }), checkViewItem && checkViewItem.checkGuide.length > 0 && (_jsx("button", Object.assign({ type: "button", className: "btn btn-info lm-block js-open-m-1650", "data-pop": "m-1650", onClick: (e) => M1650Pop(e, 1) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC810\uAC80\uAC00\uC774\uB4DC" })) })))] })), _jsx("div", Object.assign({ className: "box__body" }, { children: _jsxs("section", Object.assign({ className: "flex-row m-m24" }, { children: [_jsxs("div", Object.assign({ className: "body-left" }, { children: [_jsx("p", Object.assign({ className: "txt-info icon" }, { children: checkViewItem.description })), check.listType == 1 ? (_jsx("div", Object.assign({ className: "left-top" }, { children: _jsxs("div", Object.assign({ className: "scorebox-list" }, { children: [checkViewItem.checkItemRef.map((checks, idx) => (_jsxs("a", Object.assign({ href: "#", className: `scorebox ${check.checkvalue.isChecked == false && check.checkvalue.value == checks.score ? "selected" : ""} `, onClick: (e) => CheckViewClick(e, checks) }, { children: [_jsxs("p", Object.assign({ className: "score" }, { children: [checks.score, t("라벨.점")] })), _jsx("ul", Object.assign({ className: "score-list" }, { children: _jsx("li", { children: _jsx("span", { children: checks.reference }) }) }))] }), "checkType1_" + idx.toString()))), _jsxs("a", Object.assign({ href: "#", className: `scorebox ${check.checkvalue.isChecked == true ? "selected" : ""} `, onClick: (e) => CheckViewChecked(e) }, { children: [_jsx("p", Object.assign({ className: "score" }, { children: t("라벨.판정불가") })), _jsx("ul", Object.assign({ className: "score-list" }, { children: _jsx("li", { children: _jsx("span", { children: t("라벨.판정이불가함") }) }) }))] })), _jsx("ul", Object.assign({ className: "lm-block clicktab-list" }, { children: checkViewItem.checkGuide.length > 0
                                                        ? tabData.map((tab, idx) => (_jsx("li", Object.assign({ className: "js-open-m-1650", "data-pop": "m-1650", onClick: (e) => M1650Pop(e, tab.id) }, { children: tab.name }), "tabm_" + idx.toString())))
                                                        : tabData
                                                            .filter((nonf) => nonf.id !== 1)
                                                            .map((tab, idx) => (_jsx("li", Object.assign({ className: "js-open-m-1650", "data-pop": "m-1650", onClick: (e) => M1650Pop(e, tab.id) }, { children: tab.name }), "tabm_" + idx.toString()))) }))] })) }))) : check.listType == 2 ? (_jsxs("div", Object.assign({ className: "left-top" }, { children: [_jsx("div", Object.assign({ className: "value-box" }, { children: _jsx("ul", Object.assign({ className: "form__input" }, { children: _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.측정값") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", id: "t1", className: errorList.filter((err) => err.field === "input").length > 0 ? "input-error" : "", placeholder: t("라벨.측정값을입력헤주세요"), value: checkInput, onChange: (e) => onChangeInput(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "input").map((err) => err.msg) })), _jsxs("div", Object.assign({ className: "btn-area" }, { children: [_jsx("button", Object.assign({ type: "button", className: `${check.checkvalue.isChecked == true ? "bg-gray" : ""} `, onClick: (e) => CheckInputClick(e) }, { children: _jsx("span", { children: t("라벨.적용") }) })), _jsx("button", Object.assign({ type: "button", className: `btn-not scorebox ${check.checkvalue.isChecked == true ? "selected" : ""} `, onClick: (e) => CheckViewChecked(e) }, { children: _jsx("span", { children: t("라벨.판정불가") }) }))] }))] }))] }) })) })), _jsxs("div", Object.assign({ className: "tbl__top" }, { children: [_jsx("span", Object.assign({ className: `tit ${check.checkvalue.isChecked == true ? "disabled" : ""} ` }, { children: t("라벨.입력내용") })), check.checkvalue.input >= 0 && check.checkvalue.isChecked == false && (_jsx("span", Object.assign({ className: "input-value " }, { children: check.checkvalue.input })))] })), _jsx("div", Object.assign({ className: "tbl-list" }, { children: _jsxs("table", Object.assign({ summary: "\uD3C9\uAC00 \uAE30\uC900,\uBC30\uC810 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uCE21\uC815\uAC12\uAE30\uC900 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uCE21\uC815\uAC12\uAE30\uC900 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "80%" } }), _jsx("col", { style: { width: "20%" } })] }), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col", className: "txt-left" }, { children: t("라벨.평가기준") })), _jsx("th", Object.assign({ scope: "col", className: "txt-right" }, { children: t("라벨.배점") }))] }) }), _jsxs("tbody", { children: [checkViewItem.checkItemRef.map((checks, idx) => (_jsxs("tr", Object.assign({ className: `${check.checkvalue.isChecked == false && check.checkvalue.value == checks.score ? "selected" : ""}` }, { children: [_jsx("td", { children: checks.reference }), _jsxs("td", Object.assign({ className: "txt-right" }, { children: [checks.score, t("라벨.점")] }))] }), "checkType2_" + idx.toString()))), _jsxs("tr", Object.assign({ className: `scorebox ${check.checkvalue.isChecked == true ? "selected" : check.checkvalue.value ? "" : ""} ` }, { children: [_jsx("td", { children: t("라벨.판정이불가함") }), _jsx("td", Object.assign({ className: "txt-right" }, { children: t("라벨.판정불가") }))] }))] })] })) })), _jsx("ul", Object.assign({ className: "lm-block clicktab-list" }, { children: checkViewItem.checkGuide.length > 0
                                                    ? tabData.map((tab, idx) => (_jsx("li", Object.assign({ className: "js-open-m-1650", "data-pop": "m-1650", onClick: (e) => M1650Pop(e, tab.id) }, { children: tab.name }), "tabm_" + idx.toString())))
                                                    : tabData
                                                        .filter((nonf) => nonf.id !== 1)
                                                        .map((tab, idx) => (_jsx("li", Object.assign({ className: "js-open-m-1650", "data-pop": "m-1650", onClick: (e) => M1650Pop(e, tab.id) }, { children: tab.name }), "tabm_" + idx.toString()))) }))] }))) : (check.listType == 3 && (_jsxs("div", Object.assign({ className: "left-top scrollH" }, { children: [checkViewItem.checkItemRef.length <= 1 ? (_jsx("div", Object.assign({ className: "value-box" }, { children: _jsx("ul", Object.assign({ className: "form__input" }, { children: checkRefItem.map((item, idx) => (_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: item.measure })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", id: "t1", placeholder: t("라벨.측정값을입력헤주세요"), className: errorList.filter((err) => err.field === "measureValue").length > 0
                                                                            ? "input-error"
                                                                            : "", value: item.measureValue || "", onChange: (e) => onChangeInputType(e, item) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "measureValue").map((err) => err.msg) })), _jsx("div", Object.assign({ className: "btn-area" }, { children: _jsx("button", Object.assign({ type: "button", onClick: (e) => CheckType3(e) }, { children: _jsx("span", { children: t("라벨.적용") }) })) }))] }))] }, "input_" + idx.toString()))) })) }))) : (_jsxs("div", Object.assign({ className: "value-box more" }, { children: [checkRefItem.map((item, idx) => {
                                                        if (idx % 2 === 0) {
                                                            return (_jsxs("ul", Object.assign({ className: "form__input" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: item.measure })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", id: "t1", className: errorList.filter((err) => err.field === "measureValue").length > 0
                                                                                            ? "input-error"
                                                                                            : "", placeholder: t("라벨.측정값을입력헤주세요"), value: item.measureValue || "", onChange: (e) => onChangeInputType(e, item) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "measureValue").map((err) => err.msg) }))] }))] }), checkRefItem[idx + 1] && (_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: checkRefItem[idx + 1].measure })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", id: "t2", className: errorList.filter((err) => err.field === "measureValue").length > 0
                                                                                            ? "input-error"
                                                                                            : "", placeholder: t("라벨.측정값을입력헤주세요"), value: checkRefItem[idx + 1].measureValue || "", onChange: (e) => onChangeInputType(e, checkRefItem[idx + 1]) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList
                                                                                            .filter((err) => err.field === "measureValue")
                                                                                            .map((err) => err.msg) }))] }))] }))] }), "inputs_" + idx.toString()));
                                                        }
                                                    }), _jsx("div", Object.assign({ className: "btn-area" }, { children: _jsx("button", Object.assign({ type: "button", onClick: (e) => CheckType3(e) }, { children: _jsx("span", { children: t("라벨.적용") }) })) }))] }))), _jsx("div", Object.assign({ className: "tbl__top" }, { children: _jsx("span", Object.assign({ className: "tit" }, { children: t("라벨.입력내용") })) })), check.checkvalueId > 0 && (_jsx("ul", Object.assign({ className: "input-list" }, { children: checkRefView.length > 0
                                                    ? checkRefView.map((item, idx) => {
                                                        if (idx % 2 === 0) {
                                                            return (_jsxs("li", { children: [_jsxs("p", { children: [_jsx("span", { children: item.measure }), _jsx("span", { children: _jsx("strong", { children: item.measureValue ? item.measureValue : t("라벨.입력내용없음") }) })] }), checkRefView[idx + 1] && (_jsxs("p", { children: [_jsx("span", { children: checkRefView[idx + 1].measure }), _jsx("span", { children: _jsx("strong", { children: checkRefView[idx + 1].measureValue
                                                                                        ? checkRefView[idx + 1].measureValue
                                                                                        : "입력 내용 없음" }) })] }))] }, "list3_" + idx.toString()));
                                                        }
                                                    })
                                                    : checkRefItem.map((item, idx) => {
                                                        if (idx % 2 === 0) {
                                                            return (_jsxs("li", { children: [_jsxs("p", { children: [_jsx("span", { children: item.measure }), _jsx("span", { children: _jsx("strong", { children: t("라벨.입력내용없음") }) })] }), checkRefItem[idx + 1] && (_jsxs("p", { children: [_jsx("span", { children: checkRefItem[idx + 1].measure }), _jsx("span", { children: _jsx("strong", { children: t("라벨.입력내용없음") }) })] }))] }, "list3_" + idx.toString()));
                                                        }
                                                    }) }))), _jsx("div", Object.assign({ className: "tbl-list" }, { children: _jsxs("table", Object.assign({ summary: "\uCE21\uC815\uAC12,\uC124\uBA85 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uCE21\uC815\uAC12\uAE30\uC900 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uCE21\uC815\uAC12\uAE30\uC900 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "28%" } }), _jsx("col", { style: { width: "72%" } })] }), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col", className: "txt-left" }, { children: t("라벨.측정값") })), _jsx("th", Object.assign({ scope: "col", className: "txt-left" }, { children: t("라벨.설명") }))] }) }), _jsx("tbody", { children: checkViewItem.checkItemRef.map((item, idx) => (_jsxs("tr", { children: [_jsx("td", { children: item.measure }), _jsx("td", { children: item.reference })] }, "type3_" + idx.toString()))) })] })) })), _jsx("ul", Object.assign({ className: "lm-block clicktab-list" }, { children: checkViewItem.checkGuide.length > 0
                                                    ? tabData.map((tab, idx) => (_jsx("li", Object.assign({ className: "js-open-m-1650", "data-pop": "m-1650", onClick: (e) => M1650Pop(e, tab.id) }, { children: tab.name }), "tabm_" + idx.toString())))
                                                    : tabData
                                                        .filter((nonf) => nonf.id !== 1)
                                                        .map((tab, idx) => (_jsx("li", Object.assign({ className: "js-open-m-1650", "data-pop": "m-1650", onClick: (e) => M1650Pop(e, tab.id) }, { children: tab.name }), "tabm_" + idx.toString()))) }))] })))), _jsxs("div", Object.assign({ className: "left-bottom" }, { children: [_jsx("div", Object.assign({ className: "progress-area" }, { children: _jsx("progress", { value: persent, max: "100" }) })), _jsxs("div", Object.assign({ className: "btn-area sm-column" }, { children: [_jsxs("div", Object.assign({ className: "left" }, { children: [_jsx("button", Object.assign({ type: "button", className: "btn-basic bg-gray", disabled: check.startPage == check.itemNum ? true : false, onClick: (e) => preCheckList(e) }, { children: _jsx("span", { children: t("라벨.이전") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => NextCheckLsit(e) }, { children: _jsx("span", { children: t("라벨.다음") }) }))] })), persent !== "100" && (_jsx("div", Object.assign({ className: "right" }, { children: _jsx("button", Object.assign({ type: "button", className: "btn-txt next js-open", "data-pop": "pop-confirm", onClick: (e) => CUTIL.jsopen_Popup(e) }, { children: _jsx("span", { children: t("라벨.점검완료하고결과보기") }) })) })))] }))] }))] })), _jsxs("div", Object.assign({ className: "body-right  m-popup m-hidden", id: "m-1650" }, { children: [_jsxs("div", Object.assign({ className: "box__header" }, { children: [_jsx("button", Object.assign({ className: "btn btn-prev js-close ", onClick: (e) => closePopup("m-1650") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC774\uC804\uD398\uC774\uC9C0\uB85C" })) })), _jsx("p", Object.assign({ className: "box__title" }, { children: checkViewItem.name }))] })), _jsx("ul", Object.assign({ className: "tab__line" }, { children: checkViewItem.checkGuide.length > 0
                                            ? tabData.map((tab, idx) => (_jsx("li", Object.assign({ className: `click-tab ${tab.id == tabNum ? "on" : ""}`, "data-tab": "tab" + tab.id, onClick: (e) => TabClick(tab) }, { children: tab.name }), "tabs_" + idx.toString())))
                                            : tabData
                                                .filter((nonf) => nonf.id !== 1)
                                                .map((tab, idx) => (_jsx("li", Object.assign({ className: `click-tab ${tab.id == tabNum ? "on" : ""}`, "data-tab": "tab" + tab.id, onClick: (e) => TabClick(tab) }, { children: tab.name }), "tabs_" + idx.toString()))) })), _jsxs("div", Object.assign({ className: "right-bottom" }, { children: [_jsx("div", Object.assign({ className: `tab-content ${tabNum == 1 ? "show" : ""}`, id: "tab-1" }, { children: _jsx("ul", Object.assign({ className: "imgbox-area " }, { children: checkViewItem.checkGuide.length > 0 &&
                                                        checkViewItem.checkGuide.map((guide, idx) => (_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: guide.title })), guide.files.length > 0 && (_jsx("div", Object.assign({ className: `img-area ${guide.files.map((img) => (img.name.split(".")[1] == "png" || img.name.split(".")[1] == "jpeg" || img.name.split(".")[1] == "jpg" ? "" : "video"))}` }, { children: guide.files.map((img, i) => img.name.split(".")[1] == "png" ||
                                                                        img.name.split(".")[1] == "jpeg" ||
                                                                        img.name.split(".")[1] == "jpg" ? (_jsx("img", { src: img.url, alt: img.name }, "guideImg_" + i.toString())) : (_jsx("video", { src: img.url, controls: true }, "movi_" + i.toString()))) }))), _jsx("p", Object.assign({ className: "txt" }, { children: guide.content }))] }, "guide_" + idx.toString()))) })) })), _jsxs("div", Object.assign({ className: `tab-content ${tabNum == 2 ? "show" : ""}`, id: "tab-2" }, { children: [_jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("textarea", { placeholder: t("라벨.점검항목의견입력"), value: action || "", onChange: (e) => setAction(e.target.value), onKeyDown: (e) => CUTIL.beforeHandleComment(e, 400), onKeyUp: (e) => CUTIL.afterHandleComment(e, 400, setAction) }), _jsxs("p", Object.assign({ className: "txtnum" }, { children: [action ? action.length : "0", "/ 400"] }))] })), _jsx("div", Object.assign({ className: "flex-inline right mt-24" }, { children: _jsx("button", Object.assign({ type: "button", className: "btn-basic", onClick: (e) => CheckPut(e, "action") }, { children: _jsx("span", { children: t("라벨.저장") }) })) }))] })), _jsxs("div", Object.assign({ className: `tab-content ${tabNum == 3 ? "show" : ""}`, id: "tab-3" }, { children: [_jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("textarea", { placeholder: t("라벨.비고입력"), value: comment || "", onChange: (e) => setComment(e.target.value), onKeyDown: (e) => CUTIL.beforeHandleComment(e, 400), onKeyUp: (e) => CUTIL.afterHandleComment(e, 400, setComment) }), _jsxs("p", Object.assign({ className: "txtnum" }, { children: [comment ? comment.length : "0", " / 400"] }))] })), _jsx("div", Object.assign({ className: "flex-inline right mt-24" }, { children: _jsx("button", Object.assign({ type: "button", className: "btn-basic", onClick: (e) => CheckPut(e, "comment") }, { children: _jsx("span", { children: t("라벨.저장") }) })) }))] })), _jsxs("div", Object.assign({ className: `tab-content ${tabNum == 4 ? "show" : ""}`, id: "tab-4" }, { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.사진파일업로드") })), _jsxs("ul", Object.assign({ className: "form__input mt-24" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.제목") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp", placeholder: t("라벨.사진제목입력"), value: potoName, onChange: (e) => setPotoName(e.target.value) }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.파일불러오기") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: "filebox" }, { children: [_jsx("input", { className: "upload-name", value: "", placeholder: t("라벨.사진첨부하세요"), readOnly: true }), _jsx("label", Object.assign({ htmlFor: "file" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uD30C\uC77C\uCC3E\uAE30" })) })), _jsx("input", { type: "file", accept: "image/*", id: "file", multiple: true, onChange: (e) => saveFileImage(e) })] })), _jsx("p", Object.assign({ className: "txt-info" }, { children: t("라벨.첨부500MB") })), file.map((img, idx) => (_jsx("ul", Object.assign({ className: "filelist" }, { children: _jsxs("li", { children: [_jsx("span", { children: img.name }), _jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => onClickAttachFileDelete(idx) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))] }) }), "img_" + idx.toString()))), _jsx("div", Object.assign({ className: "flex-inline right mt-24" }, { children: _jsx("button", Object.assign({ type: "button", className: "btn-basic", onClick: (e) => uploadFileImage(e) }, { children: _jsx("span", { children: t("라벨.업로드") }) })) }))] }))] })] })), _jsxs("div", Object.assign({ className: "imglist" }, { children: [_jsxs("p", Object.assign({ className: "tit" }, { children: [_jsx("span", { children: t("라벨.첨부사진내역") }), _jsxs("span", { children: [uploadFiles.length, "/10"] })] })), _jsx("ul", Object.assign({ className: "imgbox-area" }, { children: uploadFiles.map((img, idx) => (_jsxs("li", { children: [_jsxs("p", Object.assign({ className: "tit" }, { children: [_jsx("span", { children: img.groupName }), _jsxs("span", Object.assign({ className: "btn-area" }, { children: [_jsx("button", Object.assign({ type: "button", className: "btn btn-edit-g js-open", "data-pop": "pop-edit-image", onClick: (e) => ImageInfo(e, img) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC218\uC815" })) })), _jsx("button", Object.assign({ type: "button", className: "btn btn-delete-gr js-open", "data-pop": "pop-delete-image", onClick: (e) => ImageInfo(e, img) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))] }))] })), _jsx("div", Object.assign({ className: "img-area js-open", "data-pop": "pop-img", onClick: (e) => ImageInfo(e, img) }, { children: _jsx("img", { src: img.url, alt: img.name }) }))] }, "imgs_" + idx.toString()))) }))] }))] }))] }))] }))] })) }))] }))) }));
}
export default CheckView;
export function useDebounceEffect(fn, waitTime, deps) {
    useEffect(() => {
        const t = setTimeout(() => {
            fn.apply(undefined, deps);
        }, waitTime);
        return () => {
            clearTimeout(t);
        };
    }, deps);
}
function ImageEditPop(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReload = useSetRecoilState(reLoad);
    const [alert, setAlert] = useRecoilState(alertState);
    // props
    const { imageInfo, groupName, setGroupName } = props;
    function listEidt(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/image/checkvalue/groupName/${imageInfo.imageId}`,
                appQuery: {
                    groupName: groupName,
                },
                userToken: userInfo.loginInfo.token,
                watch: imageInfo,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    CUTIL.jsclose_Popup("pop-edit-image");
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-edit-image", type: CONST.TYPE_INNRE, divTag: t("라벨.수정되었습니다") }));
                    CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-edit-image");
                    setReload(false);
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("ul", Object.assign({ className: "form__input" }, { children: _jsx("li", { children: _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp2", value: groupName, onChange: (e) => setGroupName(e.target.value) }) })) }) })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-edit-image") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => listEidt(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
function ImageDeletePop(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReload = useSetRecoilState(reLoad);
    const [alert, setAlert] = useRecoilState(alertState);
    // props
    const { imageInfo } = props;
    function listDel(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "DELETE",
                appPath: `/image/${imageInfo.imageId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
                watch: imageInfo,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    CUTIL.jsclose_Popup("pop-delete-image");
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-delete-image", type: CONST.TYPE_INNRE, divTag: data.body }));
                    CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-delete-image");
                    setReload(false);
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("p", { children: t("라벨.첨부된사진을삭제하시겠습니까") }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-image-delete") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => listDel(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
function ImagePop(props) {
    const t = useTrans();
    const { url } = props;
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("div", Object.assign({ className: "img-area" }, { children: _jsx("img", { src: url, alt: "\uBD84\uC804\uC18C \uC628\uB3C4 \uC0AC\uC9C4" }) })) })), _jsx("div", Object.assign({ className: "popup__footer" }, { children: _jsx("button", Object.assign({ type: "button", className: "js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-img") }, { children: _jsx("span", { children: t("라벨.확인") }) })) }))] }));
}
